var _path, _path2, _path3, _path4, _path5;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAwsRds(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 289,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 256 289",
    width: 256,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 224.742 29.972 35.125 2.695-3.201v-224.666l-2.695-3.395-29.972 35.112z",
    fill: "#1a476f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m29.976 259.867 57.27 28.633 2.382-3.833.039-281.667-2.381-3-57.31 28.541z",
    fill: "#1f5b98"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m256 63.717-29.98-35.112-3.353 1.062.666 227.333 2.687 2.867 29.98-35.121z",
    fill: "#2d72b8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m168.75 288.5 57.27-28.633v-231.326l-57.31-28.541-2.71 3.667.039 280.666z",
    fill: "#5294cf"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m87.286 0h81.424v288.504h-81.424z",
    fill: "#2d72b8"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsRds);
export default __webpack_public_path__ + "static/media/aws-rds.a71ab19af46e51bee524e6f8e9b4105b.svg";
export { ForwardRef as ReactComponent };